import React, { Component } from "react";
import io from "socket.io-client";

import { Cursor } from "./Cursor";
import { WipeIndicator } from "./WipeIndicator";
import { BombIndicator } from "./BombIndicator";
import { GlobalMessage } from "./GlobalMessage";

import {Howl} from 'howler';

const LOCAL = process.env.REACT_APP_STAGE === 'dev';
const ENDPOINT = LOCAL ? "http://127.0.0.1:4001" : "https://f80x25.herokuapp.com";

export class TextGrid extends Component {
    constructor(props) {
        super(props);
		this.charSizeX = 8;
		this.charSizeY = 12;
        this.defaultSizeX = 80;
        this.defaultSizeY = 25;

        this.state = {
			socketid: "",
            enableTyping: false,
            showStart: false,
            showEnd: false,
            showSpecialScreen: false,
            isGod: false,
            sizeX: 0,
            sizeY: 0,
			grid: undefined,
			cursorPos: {x: Math.floor(this.defaultSizeX/2), y: Math.floor(this.defaultSizeY/2)},
			otherCursors: {},
            wipeIndicator: undefined,
            bombIndicator: undefined,
            restrictions: "",
            enableOverwrite: true,
            globalMessage: {message: "", visible: false},
            userCount: 0,
			response: false,
            endpoint: ENDPOINT
        };

		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.click = this.click.bind(this);
        this.onGodMessageKeyUp = this.onGodMessageKeyUp.bind(this);
        this.onPasswordMessageKeyUp = this.onPasswordMessageKeyUp.bind(this);

        this.selectVoice("Boing");
    }

    initSound() {
        this.soundString = "abcdefghijklmnopqrstuvwxyzäöüß.!?#ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜ";

        var translateCharToFileName = (ch) => {
            const translateTable = {
                ".": "atmen1",
                "!": "atmen2",
                "?": "atmen3",
                "#": "atmen4",
                "ß": "s"
            }

            for (var ch2 in translateTable) {
                if (ch2 === ch) {
                    return [translateTable[ch2], 0.1];
                }
            }
            return [ch.toLowerCase(), 1.0];
        };

        var sounds = {}
        for (var i = 0; i < this.soundString.length; i++) {
            let ch = this.soundString.substring(i, i+1);
            let [name, vol] = translateCharToFileName(ch);
            let directory = (ch === ch.toLowerCase()) ? "lowercase" : "uppercase";
            let soundPath = (LOCAL ? process.env.PUBLIC_URL : 'https://joerg.piringer.net/quadrat')+"/sounds/"+directory+"/"+name+'.';

            sounds[ch] = new Howl({
                src: [soundPath+"wav", soundPath+"ogg", soundPath+"mp3"],
                rate: 1.2,
                volume: 0.3 * vol,
                onloaderror: (id, msg) => {
                    console.log("error loading sound "+id+"("+soundPath+"): "+msg);
                }
            });
        }
        this.setState({sounds: sounds});
    }

    playSound(c) {
        //let c = ch.toLowerCase();

        if (this.state.sounds[c] !== undefined) {
            this.state.sounds[c].play();
        }
        else {
            this.state.sounds["#"].play();
        }
    }

    selectVoice(name) {
    	var voices = window.speechSynthesis.getVoices();
    	voices.forEach(voice => {
    		if (voice.name === name) {
    			this.selectedVoice = voice;
    		}
    	});
        if (this.selectedVoice === undefined || this.selectedVoice === null) {
            this.selectedVoice = voices[0];
        }
    }

    speak(text) {
        if (this.props.useControls) {
            let synth = window.speechSynthesis;
    		var msg = new SpeechSynthesisUtterance();
    		msg.voice = this.selectedVoice; // Note: some voices don't support altering params
    		msg.voiceURI = 'native';
    		msg.text = text;
    		msg.lang = 'en-US';
    		msg.volume = 1; // 0 to 1
    		msg.rate = 2; // 0.1 to 10
    		msg.pitch = 0.5; //0 to 2

            synth.cancel();
    		synth.speak(msg);
        }
    }

	clearGrid(sizeX, sizeY) {
		var grid = [];

		this.setState( {sizeX: sizeX, sizeY: sizeY});

		for (var x = 0; x < sizeX; x++) {
			var column = [];
			for (var y = 0; y < sizeY; y++) {
				column[y] = " ";
			}
			grid[x] = column;
		}
		this.setState({grid: grid});
	}

    componentDidMount() {
        this.initSound();

		this.clearGrid();

		const { endpoint } = this.state;
		this.socket = io(endpoint);

		this.socket.on("init", data => {
			this.setState({socketid: data.id});
			this.removeOtherCursor(data.id);
		});
        this.socket.on("grid", data => {
            //this.setState({userCount: data.userCount, wipeIndicator: data.wipeIndicator, bombIndicator: data.bombIndicator});
			this.setState(data);
		});
        this.socket.on("transactions", data => {
            let transactions = data.transactions;
            delete data["transactions"];
			this.setState(data);

            var grid = this.state.grid;
            Object.keys(transactions).forEach(function(key) {
                let transaction = transactions[key];
                grid[transaction.x][transaction.y] = transaction.ch;
            });
            this.setState({ grid: grid});
		});
        this.socket.on("indicator", data => {
            this.setState({wipeIndicator: data.wipeIndicator});
            this.setState({bombIndicator: data.bombIndicator});
        });
		this.socket.on("setChar", data => {
			this._setCharAt(data.x, data.y, data.ch);
		});
		this.socket.on("newCursor", data => {
            this.setState({userCount: data.userCount});
			this.setOtherCursor(data.id, 0, 0);
		});
		this.socket.on("removeCursor", data => {
            this.setState({userCount: data.userCount});
			this.removeOtherCursor(data.id);
		});
		this.socket.on("otherCursorPos", data => {
            this.setState({userCount: data.userCount});
		    this.setOtherCursor(data.id, data.x, data.y);
		});
        this.socket.on("globalMessage", data => {
            this.displayGlobalMessage(data.message, data.timeOut);
        });
        this.socket.on("enableTyping", data => {
            this.setState({enableTyping: data.enable});
        });
        this.socket.on("restrictions", data => {
            this.setState({restrictions: data.restrictions});
        });
        this.socket.on("enableOverwrite", data => {
            this.setState({enableOverwrite: data.enable});
        });
        this.socket.on("showStart", data =>{
            this.setState({showSpecialScreen: data.show, showStart: data.show});
        });
        this.socket.on("showEnd", data =>{
            this.setState({showSpecialScreen: data.show, showEnd: data.show});
        });
        this.socket.on("youAreGod", data =>{
            this.setState({isGod: data.isGod});
        });
    }

	setOtherCursor(id, x, y) {
		if (id !== this.state.socketid) {
			var otherCursors = this.state.otherCursors;

			otherCursors[id] = {x: x, y: y};
			this.setState( {otherCursors: otherCursors});
		}
	}

	removeOtherCursor(id) {
		if (id !== this.state.socketid) {
			var otherCursors = this.state.otherCursors;

			delete otherCursors[id];
			this.setState( {otherCursors: otherCursors});
		}
	}

	_setCharAt(x, y, ch) {
		var grid = this.state.grid;

		grid[x][y] = ch;
		this.setState({grid: grid});
        this.playSound(ch);
	}

	setChar(ch) {
        this._setCharAt(this.state.cursorPos.x, this.state.cursorPos.y, ch)
	}

	alertProblem() {

	}

	setCurPos(x, y) {
		this.setState({ cursorPos: {x: x, y: y}});
		this.socket.emit("setCursorPos", {x: x, y: y});
	}

	advanceCursor() {
		var xn = this.state.cursorPos.x+1;
		var yn = this.state.cursorPos.y;

		if (xn >= this.state.sizeX) {
			if (yn >= this.state.sizeY-1) { // no possible
				this.alertProblem();
				xn--;
			}
			else {
				xn = 0;
				yn++;
			}
		}
		this.setCurPos(xn, yn);
	}

    isAllowedChar(ch) {
        if (this.state.restrictions === "") {
            return true;
        }
        return this.state.restrictions.includes(ch);
    }

	enterChar(ch) {
        if (this.state.enableTyping && this.isAllowedChar(ch)) {
            if (!this.state.enableOverwrite && this.getCharAt(this.state.cursorPos.x, this.state.cursorPos.y) !== " ") {

            }
            else {
		        this.socket.emit("setChar", {x: this.state.cursorPos.x, y: this.state.cursorPos.y, ch: ch});
		        this.setChar(ch);
		        this.advanceCursor();
            }
        }
	}

	getCharAt(x, y) {
		if (this.state.grid === undefined) {
			return " ";
		}
		return this.state.grid[x][y];
	}

    displayGlobalMessage(message, timeOut) {
        clearInterval(this.previousMessageTimeOut);
        this.setState({globalMessage: {message: message, visible: true}});
        this.previousMessageTimeOut = setTimeout(() => {this.setState({globalMessage: {message: this.state.globalMessage.message, visible: false}});}, timeOut*1000+1);
    }

    takeAction(actionName) {
        this.speak(actionName);
        this.socket.emit("action", {actionName: actionName, cursorPos: this.state.cursorPos});
    }

	handleKeyDown(event) {
		//console.log('key pressed: '+event.keyCode);
		switch (event.keyCode) {
			case 37: // left
				this.setCurPos(Math.max(0, this.state.cursorPos.x-1), this.state.cursorPos.y);
				break;
			case 39: // right
				this.setCurPos(Math.min(this.state.sizeX-1, this.state.cursorPos.x+1),this.state.cursorPos.y);
				break;
			case 38: // up
				this.setCurPos(this.state.cursorPos.x, Math.max(0, this.state.cursorPos.y-1));
				break;
			case 40: // down
				this.setCurPos(this.state.cursorPos.x, Math.min(this.state.sizeY-1, this.state.cursorPos.y+1));
				break;
			default:
				if (event.key.length > 1) {
					console.log(event.key);
				}
				else {
					this.enterChar(event.key);
				}
				break;
		}
	}

	click(event) {
        //let bodyRect = document.body.getBoundingClientRect();
        let bounds = document.querySelector(".GridBox").getBoundingClientRect();
        let mx = event.clientX - bounds.left; //-bodyRect.left);
        let my = event.clientY - bounds.top; // - bodyRect.top);
        //console.log(mx, my, bounds.top, bounds.left);
		var cx = Math.max(0, Math.round(mx / this.charSizeX) - 1);
		var cy = Math.max(0, Math.floor(my / this.charSizeY) - 1);
		this.setCurPos(cx, cy);
	}

	gridText() {
		var items = [];

		for (var y = 0; y < this.state.sizeY; y++) {
			for (var x = 0; x < this.state.sizeX; x++) {
				items.push(
					<div className="GridText" key={"x"+x+"y"+y} style={{left: x*8, top: y*12, position:'absolute'}}>
						{this.getCharAt(x, y)}
					</div>
				);
			}
		}

		return items;
	}

	renderOtherCursors(otherCursors) {
		var items = [];

		for (var cursorid in otherCursors) {
			if (cursorid !== this.state.socketid) {
				var cursorPos = otherCursors[cursorid];
				//console.log(cursorid, cursorPos);
				items.push(<Cursor pos={cursorPos} key= {cursorid} color="#0000ff" />);
			}
		}

		return items;
	}

    renderIndicators() {
        if (this.state.wipeIndicator !== undefined) {
            return <WipeIndicator pos={this.state.wipeIndicator} height={this.state.sizeY * this.charSizeY}/>;
        }
        if (this.state.bombIndicator !== undefined) {
            return <BombIndicator pos={{x: this.state.bombIndicator.pos.x*this.charSizeX, y: this.state.bombIndicator.pos.y*this.charSizeY}} size={{width: this.state.bombIndicator.size * this.charSizeX, height: this.state.bombIndicator.size * this.charSizeY}}/>;
        }
        return <></>;
    }

    renderGlobalMessage() {
        //return <GlobalMessage message={this.state.globalMessage.message} visible={this.state.globalMessage.visible} />;
        return <GlobalMessage message={this.state.globalMessage.message} show={this.state.globalMessage.visible} />;
    }

    renderStatusMessage() {
        var userMessage = "";

        switch(this.state.userCount) {
            case 0:
                userMessage = "nobody online. how is that possible? are you nobody?";
                break;
            case 1:
                userMessage = "you are the only one online.";
                break;
            default:
                userMessage = ""+this.state.userCount+" users online.";
                break;
        }

        var restrictions = this.state.enableTyping ? (this.state.restrictions === "" ? "no restrictions. you can type whatever you like." : "you can only use the following characters: "+this.state.restrictions) : "you are not allowed to type at the moment!";

        var overwrite = this.state.enableOverwrite ? "" : "you can not overwrite characters!";

        return  <>
                    {userMessage}<br />
                    {this.state.showStart ? <><br /></> :
                        <>
                            {restrictions}<br />
                            {overwrite}
                        </>
                    }
                </>
                ;
    }

    onGodMessageKeyUp(event) {
        if (event.key === "Enter") {
            let message = event.target.value;
            this.socket.emit("godMessage", {message: message});
            event.target.value = "";
        }
    }

    onPasswordMessageKeyUp(event) {
        if (event.key === "Enter") {
            let password = event.target.value;
            this.socket.emit("iAmGod", {password: password});
            event.target.value = "";
        }
    }

    renderControls() {
        return this.props.useControls ?
            (this.state.isGod ?
            <>
                <button onClick={() => {this.takeAction('showStart')}}>showStart</button>
                <button onClick={() => {this.takeAction('showEnd')}}>showEnd</button>
                <button onClick={() => {this.takeAction('hideStart')}}>hideStart/End</button>
                <button onClick={() => {this.takeAction('startAuto')}}>start auto</button>
                <button onClick={() => {this.takeAction('stopAuto')}}>stop auto</button>
                <button onClick={() => {this.takeAction('disableTyping')}}>disableTyping</button>
                <button onClick={() => {this.takeAction('enableTyping')}}>enableTyping</button>
                <button onClick={() => {this.takeAction('disableOverwrite')}}>disableOverwrite</button>
                <button onClick={() => {this.takeAction('enableOverwrite')}}>enableOverwrite</button>
                <br />
                <button onClick={() => {this.takeAction('wipe')}}>wipe</button>
                <button onClick={() => {this.takeAction('bomb')}}>bomb</button>
                <button onClick={() => {this.takeAction('gravity')}}>gravity</button>
                <button onClick={() => {this.takeAction('fill')}}>fill</button>
                <button onClick={() => {this.takeAction('rain')}}>rain</button>
                <button onClick={() => {this.takeAction('wind')}}>wind</button>
                <br />
                <button onClick={() => {this.takeAction('noRestrictions')}}>noRestrictions</button>
                <button onClick={() => {this.takeAction('onlyConsonants')}}>onlyConsonants</button>
                <button onClick={() => {this.takeAction('onlyVowels')}}>onlyVowels</button>
                <button onClick={() => {this.takeAction('onlyCapitalLetters')}}>onlyCapitalLetters</button>
                <button onClick={() => {this.takeAction('onlyLowercaseLetters')}}>onlyLowercaseLetters</button>
                <button onClick={() => {this.takeAction('onlyPunctuation')}}>onlyPunctuation</button>
                <button onClick={() => {this.takeAction('onlyNumbers')}}>onlyNumbers</button>
                <br />
                <input type="text" name="godMessage" size={40} placeholder="message from god" onKeyUp={this.onGodMessageKeyUp} />
            </>
            :
            <>
                <input type="password" name="password" size={40} placeholder="password" onKeyUp={this.onPasswordMessageKeyUp} />
            </>)
            :
            <>
            </>;
    }

    renderSpecialScreen() {
        return this.state.showStart ?
        <div className="StartScreen">
            <p>welcome to 80x25!</p>
            <p>we are starting in a moment</p>
            <p>if you'd like to join in please go to:</p>
            <p>https://joerg.piringer.net/80x25</p>
            <p>if you are already here, stay tuned</p>
        </div>
        :
        <div className="StartScreen">
            <p>THE END</p>
            <p>thank you for participating!</p>
            <p>this is it for today.</p>
            <p>if you'd like to try it out yourself:</p>
            <p>https://joerg.piringer.net/80x25</p>
        </div>;
    }

    render() {
        return (
            <>
                <div className="HeadlineBox">
                    <h1>80x25</h1>
                </div>
                {this.state.showSpecialScreen ?
                    this.renderSpecialScreen()
                    :
                    <div className="GridBox" onKeyDown={this.handleKeyDown} onClick={this.click} tabIndex="0" >
        				{this.gridText()}
        				<Cursor pos={this.state.cursorPos} color={this.state.enableTyping ? "#ff0000" : "#aaaaaa"} />
        				{this.renderOtherCursors(this.state.otherCursors)}
                        {this.renderIndicators()}
                        {this.renderGlobalMessage()}
        			</div>
                }
                <div className="StatusMessageBox">
                    <p>{this.renderStatusMessage()}</p>
                    {this.renderControls()}
                    <p className="CopyrightNotice"><em>80x25</em> is a project by <a href="https://joerg.piringer.net" target="_blank" rel="noopener noreferrer">joerg piringer</a></p>
                </div>
            </>
        );
    }
}

export default TextGrid;
